import apiPostRequest from "../apiPostReguest";

export function createMeeting(formData) {
  const url = '/api/v1/booking/meetings'
  
  return apiPostRequest(url, formData);
}

export default createMeeting;
